<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/element-ui.png" /></div>
      <p>Element</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/element/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "9.3.0",
          linkList: [
            ur + "9.3.0/highlight.pack.js",
            ur + "9.3.0/color-brewer.css"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListElement.vue